import { Mesh } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../../assets/models/team2/SubTopic3/GLB_YeloxProceso.glb";
import { GUI } from "dat.gui";
import { gsap } from "gsap";
import ObserverEmitter, { EVENTS } from "../../../../../emitter/Observer";

export class YeloxProceso extends Mesh {
	constructor(camera, loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		this.camera = camera;
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.scale.set(2, 2, 2);
		this.observerListtneners();
		// this.helpers();
	}

	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			// gltf.scene.visible = false;
			this.add(gltf.scene);
			this.Sobre_Frappe = gltf.scene.getObjectByName("Sobre_Frappe", true);
			this.MaquinaYelox = gltf.scene.getObjectByName("MaquinaYelox", true);
			this.Jarra = gltf.scene.getObjectByName("Jarra", true);
			this.Tapa_01_Yelox = gltf.scene.getObjectByName("Tapa_01_Yelox", true);
			this.Corbatin = gltf.scene.getObjectByName("Corbatin", true);
		});
	}

	onvisibleObjects() {
		// this.MaquinaYelox.visible = false;
		this.Sobre_Frappe.visible = false;
		this.Jarra.visible = false;
		this.Corbatin.visible = false;

		//* material
		const newMaterialTapa_01_Yelox = this.Tapa_01_Yelox.material.clone();
		newMaterialTapa_01_Yelox.opacity = 1;
		newMaterialTapa_01_Yelox.transparent = true;
		newMaterialTapa_01_Yelox.emissiveIntensity = 1;
		this.Tapa_01_Yelox.material = newMaterialTapa_01_Yelox;

		// this.helpersChild();
	}

	onEliminateScene() {
		if (this.animation) {
			this.animation.kill();
		}
		this.visible = false;
	}

	observerListtneners() {
		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityFive.visibleCupWater, () => {
			this.Jarra.position.set(-0.158, 0.2875, 0.4704);
			this.Jarra.visible = true;
		});

		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityFive.visibleBagFrappe, () => {
			this.Sobre_Frappe.position.set(0.0218, 0.5676, 0.4704);
			this.Sobre_Frappe.rotation.set(3.0951, 0, 1.9923);
			this.Sobre_Frappe.visible = true;
		});

		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityFive.hiddenCupAndFrappe, () => {
			this.Jarra.visible = false;
			this.Sobre_Frappe.visible = false;
		});

		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityFive.animationsSaveCupWaterInit, () => {
			this.onAnimateSaveCup();
		});

		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityFive.animationsCloseCupWaterInit, () => {
			this.onAnimateCloseCup();
		});

		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityFive.visibleexpiration, () => {
			this.Corbatin.visible = true;
		});
		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityFive.hiddenexpiration, () => {
			this.Corbatin.visible = false;
		});
	}

	onAnimateCloseCup() {
		this.Jarra.visible = false;
		gsap.to(this.Tapa_01_Yelox.material, {
			opacity: 1,
			duration: 1,
			onComplete: () => {
				ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityFive.tooltip.on);
				ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityFive.animationsCloseCupWaterFinish);
			},
		});
	}

	onAnimateSaveCup() {
		this.Jarra.position.set(0.0615, 0.7015, 0.0391);
		gsap.to(this.Tapa_01_Yelox.material, {
			opacity: 0,
			duration: 1,
			onComplete: () => {
				this.Jarra.visible = true;
				gsap.to(this.Jarra.position, {
					x: 0.0987,
					y: 0.7447,
					duration: 1,
					onComplete: () => { },
				});
				gsap.to(this.Jarra.rotation, {
					z: 1.1101,
					duration: 1,
					onComplete: () => {
						ObserverEmitter.emit(EVENTS.team2.subtopicThree.activityFive.animationsSaveCupWaterFinish);
					},
				});
			},
		});
	}

	onAnimate(object, previousObject) {
		if (this.animation) {
			this.animation.kill();
		}

		//*regresar el color al anterior
		this.beforeColor = object.material.emissive;
		if (previousObject !== undefined) {
			if (this[previousObject] !== undefined) {
				this[previousObject].material.emissive = this.beforeColor;
			}
		}

		const newMaterial = object.material.clone();
		object.material = newMaterial;

		object.material.emissive.set("#404040");

		this.animation = gsap.to(object.material, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
	}

	helpers() {
		const gui = new GUI();
		const premiaFolder = gui.addFolder("Yelox");
		premiaFolder.add(this.position, "x", -20, 20).step(0.0001).name("Posición X");
		premiaFolder.add(this.position, "y", -20, 20).step(0.0001).name("Posición Y");
		premiaFolder.add(this.position, "z", -20, 20).step(0.0001).name("Posición Z");
		premiaFolder.add(this.rotation, "x", -5, 5).step(0.0001).name("rotation X");
		premiaFolder.add(this.rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		premiaFolder.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
	}

	helpersChild() {
		this.helperMethod("Corbatin", this.Corbatin);
	}

	helperMethod(name, object) {
		const { position, rotation } = object;
		const gui = new GUI();
		const folferMostrador = gui.addFolder(name);
		folferMostrador.add(position, "x", -20, 20).step(0.0001).name("Posición X");
		folferMostrador.add(position, "y", -20, 20).step(0.0001).name("Posición Y");
		folferMostrador.add(position, "z", -20, 20).step(0.0001).name("Posición Z");
		folferMostrador.add(rotation, "x", -5, 5).step(0.0001).name("rotation X");
		folferMostrador.add(rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		folferMostrador.add(rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		folferMostrador.add(object, "visible").name("Visible");
	}

	renderAnimations() { }
}
